// https://stripe.com/docs/recipes/elements-react

import React, {Component} from 'react';
import {CardElement, injectStripe} from 'react-stripe-elements';
import LoadingSpinner from "../Utils/LoadingSpinner";
import OrderStatus from "./OrderStatus";

class CreditCardForm extends Component {
    state = {
        loading: false, // will be true when ajax request is running
        complete: false, // Payment complete
        result: null, // Payment results
    };

    submit = (ev) => {
        ev.preventDefault();

        this.props.stripe.createToken({name: "Name"}).then(
            (result) => {
                console.log(JSON.stringify(result));
                if ( result.hasOwnProperty('error') ) {
                    alert(JSON.stringify(result.error));
                }else{
                    this.setState({loading:true}, () => {
                        this.props.simGps.submitCreditCardCharge(result.token.id, this.props.dev_uuid, this.props.amount,
                            (success, result) => {
                                if( success) {
                                    this.setState({loading: false, complete:true, result: result});
                                }else{
                                    this.setState({loading: false, complete:true, result: {
                                            paid: false,
                                            message: JSON.stringify(result)
                                        }});
                                }
                            }
                        );
                        }
                    );
                }
            }
        );
    };


    render() {
        let creditCardForm;
        if( this.state.loading ) {
            creditCardForm = (<LoadingSpinner text="Processing the payment ..."/>);
        } else if ( this.state.complete ) {
            if (this.state.result.paid ){
                creditCardForm = (
                    <div>
                        <h1>Payment sucessfull.</h1>
                        <OrderStatus
                            {...this.state.result.order}
                        />
                    </div>
                )
            } else {
                creditCardForm = (<div> Payment failed </div>)
            }
        } else {
            creditCardForm = (
                <form onSubmit={this.submit}>
                    <p>
                        Please enter your credit card information to pay {this.props.amount} dollars
                    </p>
                        <CardElement/>
                        <input type='submit' />
                </form>
            );
        }

        return ( <div>  {creditCardForm} </div> )
    }
}

export default injectStripe(CreditCardForm);
